module.exports = __webpack_public_path__ + "img/savology-wf-8.d40e5899.jpg";